import { createContext, useState, useContext, useEffect } from "react";
import { getOnlineNode } from "../core/getNode";
import { client } from "../config";

const SlideConfigContext = createContext();

export const useSlideConfig = () => useContext(SlideConfigContext);


export const SlideConfigProvider = ({ children }) => {
  const [slideConfig, setSlideConfig] = useState(null);
  const [configLoading, setConfigLoading] = useState(true);

  useEffect(() => {
    const loadSlideConfig = async () => {
      try {
        const response = await getOnlineNode("api/v2/presenter/slide-config");
        if (response?.data) {
          setSlideConfig(response.data);
        }
      } catch (error) {
        console.error("Failed to load slide config:", error);
      } finally {
        setConfigLoading(false);
      }
    };

    if (client !== 'equans') {
      loadSlideConfig();
    }
  }, []);

  return (
    <SlideConfigContext.Provider value={{ slideConfig, configLoading }}>
      {children}
    </SlideConfigContext.Provider>
  );
};
